
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetPtype1Off as ObiMosfetPtype1OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ptype-1-off.js';
 
 
 

 
 export const ObiMosfetPtype1Off = createComponent({
   react: React,
   tagName: 'obi-mosfet-ptype-1-off',
   elementClass: ObiMosfetPtype1OffElement,
   events: {
     
   }
  });
 
 